import { render, staticRenderFns } from "./img-lupa.vue?vue&type=template&id=db3e2362&scoped=true&"
import script from "./img-lupa.vue?vue&type=script&lang=js&"
export * from "./img-lupa.vue?vue&type=script&lang=js&"
import style0 from "./img-lupa.vue?vue&type=style&index=0&id=db3e2362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3e2362",
  null
  
)

export default component.exports